import { AxisBottom } from '@visx/axis';
import type { ScaleLinear } from 'd3-scale';
import type { D3Scale } from '@visx/scale';
import { useTheme } from '@simplywallst/ui-core';

interface Props {
  top: number;
  xPercentScale: ScaleLinear<number, number>;
  tickValues: string[];
  preferredMultiple: string;
}

const BottomAxis = ({
  xPercentScale,
  top,
  tickValues,
  preferredMultiple,
}: Props) => {
  const theme = useTheme();
  return (
    <g pointerEvents="none">
      <AxisBottom
        top={top}
        scale={xPercentScale as D3Scale<number, number>}
        tickValues={tickValues}
      >
        {({ ticks }) => {
          return (
            <g>
              <rect
                width={'100%'}
                height={1}
                y={0}
                fill={theme.color.whiteRGBA(0.2)}
              />
              {ticks.map((d, i) => (
                <g key={`bottom-axis-${i}-${d.formattedValue}`}>
                  <line
                    x1={`${d.to.x}%`}
                    x2={`${d.to.x}%`}
                    y1={1}
                    y2={5}
                    stroke={theme.color.whiteRGBA(0.2)}
                    strokeWidth={1}
                    transform={
                      i === 0
                        ? 'translate(0.5,0)'
                        : i === ticks.length - 1
                        ? 'translate(-0.5,0)'
                        : undefined
                    }
                  />
                  <text
                    x={`${d.to.x}%`}
                    y="20"
                    fontSize="12"
                    fill={theme.color.white}
                    textAnchor={
                      i === 0
                        ? 'start'
                        : i === ticks.length - 1
                        ? 'end'
                        : 'middle'
                    }
                  >
                    {i === 0 ? preferredMultiple : d.value}
                  </text>
                </g>
              ))}
            </g>
          );
        }}
      </AxisBottom>
    </g>
  );
};
export default BottomAxis;
